import {
  Component,
  OnDestroy,
  OnInit,
  Inject,
  Input,
  Output,
  EventEmitter
} from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { AppStateService } from '@pcplus/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AuthenticationService } from '../../services/authentication/authentication.service';
import { ALLOW_SELF_REGISTRATION } from '../../tokens';
import { FlexModule } from '@angular/flex-layout/flex';
import { MatCard, MatCardContent, MatCardFooter } from '@angular/material/card';
import { MatToolbar } from '@angular/material/toolbar';
import { MatIcon } from '@angular/material/icon';
import { FormsModule } from '@angular/forms';
import { MatFormField, MatSuffix, MatError } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { NgIf } from '@angular/common';
import { MatButton } from '@angular/material/button';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
    selector: 'pcp-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    imports: [FlexModule, MatCard, MatToolbar, MatIcon, MatCardContent, FormsModule, MatFormField, MatInput, MatSuffix, NgIf, MatError, MatButton, MatProgressSpinner, MatCardFooter]
})
export class LoginComponent implements OnInit, OnDestroy {
  model: any = {};
  loading = false;
  error = false;

  constructor(
    @Inject(ALLOW_SELF_REGISTRATION) public allowSelfRegistration: boolean,
    private router: Router,
    private authenticationService: AuthenticationService,
    private appState: AppStateService
  ) {}

  private onDestroy$ = new Subject<void>();
  @Input() standAlone = true;
  @Output() loggedIn = new EventEmitter();
  @Output() registerRequested = new EventEmitter();
  ngOnInit() {
    // reset login status
    this.authenticationService.logout();
    this.appState.updateCurrentModuleName($localize`Login`);
  }

  login() {
    this.loading = true;
    this.authenticationService
      .login(this.model.username, this.model.password)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe({
        next: (result) => {
          if (result === true) {
            if (this.standAlone) {
              const navigationExtras: NavigationExtras = {
                queryParamsHandling: 'preserve',
                preserveFragment: true
              };
              this.router.navigate(['/'], navigationExtras);
            } else {
              this.loggedIn.emit();
            }
          } else {
            this.error = true;
            this.loading = false;
          }
        },
        error: () => {
          this.error = true;
          this.loading = false;
        },
        complete: () => {
          this.loading = false;
        }
      });
  }

  ngOnDestroy() {
    this.onDestroy$.next();
  }
}
